<template>
  <div class="tab-wrap">
    <div class="left" ref="left">
      <div class="title" ref="title">{{title}}</div>
      <div class="english" ref="english">{{enlishTitle}}</div>
    </div>
    <div class="right">
      <span ref="rightText" class="text" :class="{'is-active': activeIndex === i}" :style="{borderColor: activeIndex === i ? color ? color: '#0167D1' : ''}" @click="handleClick(item, i)" v-for="(item, i) in list" :key="item.key">
        {{item.name}}
      </span>
      <span ref="more" class="more" @click="handleMoreClick" v-if="more">
        查看更多 <i class="icon icon-arrow-right"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => ([])
    },
    title: String,
    enlishTitle: String,
    color: String,
    more:{
      type:Boolean,
      default:true
    }
  },
  data: () => ({
    activeIndex: 0,
    current: []
  }),
  created() {
    if (this.active) {
      this.activeIndex = +this.active
    }
    if (this.list.length) {
      this.current = this.list[0]
    }
  },
  mounted() {
    if (this.color) {
      // const left = this.$refs.left
      // left.classList.add('is-after')
      const title = this.$refs.title
      const more = this.$refs.more
      const english = this.$refs.english
      const rightText = this.$refs.rightText
      english.style.color = this.color
      title.style.color = this.color
      more.style.color = this.color
      if (rightText) {
        rightText.forEach(item => {
          item.style.color = this.color
        })
      }
      console.log('rightText', rightText)
      console.log('title', title)
    }
  },
  methods: {
    handleClick(item, i) {
      this.activeIndex = i
      this.current = item
      this.$emit('titleClick', item)
    },
    handleMoreClick() {
      this.$emit('toMore', this.current)
    }
  }
}
</script>

<style>

</style>
